module.exports = __webpack_public_path__ + "static/media/Optional.047c7db5.png";